import { SDK_SCRIPT_ID, getSDKUrl } from '../settings';

import injectScript from '../utils/injectScript';
import pRetry from 'p-retry';

const retryConfig = { retries: 3, maxTimeout: 2000 };

const injectSDK = async (appKey: string): Promise<void> => {
    const url = getSDKUrl(appKey);
    await pRetry(
        async () => await injectScript(SDK_SCRIPT_ID, url),
        retryConfig
    );
};

export default injectSDK;
